import React, { useEffect, useState, useCallback } from "react";
import {
  getEquipmentTemplates,
  getEquipmentCategories,
} from "../../services/equipmentTemplates";
import "./EquipmentSelector.css";

function EquipmentSelector({ character, onSelect, onClose }) {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("TUTTE");
  const [equipments, setEquipments] = useState([]);
  const [filteredEquipments, setFilteredEquipments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  const filterEquipments = useCallback(() => {
    let filtered = [...equipments];

    // Filtra per categoria
    if (selectedCategory !== "TUTTE") {
      filtered = filtered.filter(
        (equipment) => equipment.category === selectedCategory,
      );
    }

    // Filtra per ricerca
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (equipment) =>
          equipment.name.toLowerCase().includes(term) ||
          (equipment.description &&
            equipment.description.toLowerCase().includes(term)),
      );
    }

    setFilteredEquipments(filtered);
  }, [equipments, selectedCategory, searchTerm]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    filterEquipments();
  }, [filterEquipments]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [categoriesData, equipmentsData] = await Promise.all([
        getEquipmentCategories(),
        getEquipmentTemplates(),
      ]);

      setCategories(["TUTTE", ...categoriesData.categories]);
      setEquipments(equipmentsData.equipmentTemplates);
      setFilteredEquipments(equipmentsData.equipmentTemplates);
    } catch (error) {
      console.error("Error loading equipments:", error);
      alert("Errore nel caricamento dell'equipaggiamento");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectEquipment = (equipmentTemplate) => {
    // Converti il template in formato equipaggiamento per il personaggio
    const equipment = {
      name: equipmentTemplate.name,
      category: equipmentTemplate.category,
      subcategory: equipmentTemplate.subcategory || "",
      description: equipmentTemplate.description || "",
      cost: equipmentTemplate.cost,
      quantity: 1, // Default a 1
      notes: equipmentTemplate.notes || "",
    };

    onSelect(equipment);
  };

  return (
    <div className="equipment-selector-overlay" onClick={onClose}>
      <div
        className="equipment-selector-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="equipment-selector-header">
          <h2>Seleziona Equipaggiamento</h2>
          <button className="equipment-selector-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Barra di ricerca */}
        <div className="equipment-selector-search">
          <input
            type="text"
            placeholder="Cerca equipaggiamento..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Tabs categorie */}
        <div className="equipment-selector-tabs">
          {categories.map((category) => (
            <button
              key={category}
              className={`equipment-selector-tab ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Lista equipaggiamenti */}
        <div className="equipment-selector-list">
          {loading ? (
            <div className="equipment-selector-loading">Caricamento...</div>
          ) : filteredEquipments.length === 0 ? (
            <div className="equipment-selector-empty">
              Nessun equipaggiamento trovato
            </div>
          ) : (
            filteredEquipments.map((equipment) => (
              <div
                key={equipment._id}
                className="equipment-selector-item"
                onClick={() => handleSelectEquipment(equipment)}
              >
                <div className="equipment-selector-item-header">
                  <span className="equipment-selector-item-name">
                    {equipment.name}
                  </span>
                  <span className="equipment-selector-item-cost">
                    {equipment.cost}
                  </span>
                </div>
                {equipment.subcategory && (
                  <div className="equipment-selector-item-subcategory">
                    {equipment.subcategory}
                  </div>
                )}
                {equipment.description && (
                  <div className="equipment-selector-item-description">
                    {equipment.description}
                  </div>
                )}
                {equipment.gender && equipment.gender !== "Unisex" && (
                  <div className="equipment-selector-item-gender">
                    {equipment.gender === "M" ? "Uomo" : "Donna"}
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        <div className="equipment-selector-footer">
          <button className="equipment-selector-cancel" onClick={onClose}>
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}

export default EquipmentSelector;
